/**
 * @description Used by NFilterButton in FilterButtons.js
 */
export enum RequirementStrategy {
  // As long as one of the values from the requirements is selected
  ANY,
  // Selected values has to match the requirements exactly
  MATCH,
}
